import Breadcrumbs from "components/Common/Breadcrumb";
import Loader from "components/Common/Loader";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { getFormId } from "helpers/common_helper";
import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Label,
  Row,
} from "reactstrap";
import {
  getCountryListAction,
  getStateListAction,
  saveStateAction,
} from "store/actions";
import * as Yup from "yup";

const StateAdd = props => {
  const { id } = useParams();
  const history = useHistory();
  const initialValues = {
    name: "",
    code: "",
    status: "1",
    country: "",
  };
  const [values, setValues] = useState(initialValues);
  const [country, setCountry] = useState([]);
  const validationSchema = Yup.object({
    name: Yup.string().min(2).max(100).required("Please enter state name"),
    code: Yup.string().max(4),
    country: Yup.string().required("Please select a country"),
  });
  const handleSubmit = async (values, action) => {
    try {
      props.setLoading(true);
      let response = await saveStateAction(
        {
          ...values,
          formId: getFormId(),
        },
        id
      );
      if (response.status === 1) {
        props.setLoading(false);
        toast.success(response.msg);
        if (id) {
          history.push("/panel/state/list");
        }
        action.resetForm();
      } else {
        props.setLoading(false);
        toast.error(response.msg);
      }
    } catch (error) {
      console.log(error);
      props.setLoading(false);
      let err = error?.response?.data?.msg || "Something went wrong";
      toast.error(err);
    }
  };
  useEffect(async () => {
    try {
      if (id) {
        props.setLoading(true);
        const response = await getStateListAction(id);
        if (response.status === 1) {
          setValues({
            name: response.data.name,
            code: response.data.code,
            status: `${response.data.status}`,
            country: response.data.underId,
          });
          props.setLoading(false);
        } else {
          props.setLoading(false);
          toast.error(response.msg);
        }
      }
    } catch (error) {
      props.setLoading(false);
      console.log(error);
      let err = error?.response?.data?.msg || "Something went wrong";
      toast.error(err);
    }
  }, [id]);

  useEffect(async () => {
    try {
      props.setLoading(true);
      const response = await getCountryListAction();
      if (response.status === 1) {
        let data = response?.data || [];
        data = data.filter(val => val.status === 1);
        setCountry(data);
        props.setLoading(false);
      } else {
        props.setLoading(false);
        toast.error(response.msg);
      }
    } catch (error) {
      props.setLoading(false);
      console.log(error);
      let err = error?.response?.data?.msg || "Something went wrong";
      toast.error(err);
    }
  }, []);
  const handleChange = (event, values, setValues) => {
    let { name, value } = event.target;
    value =
      name === "name" ? value.charAt(0).toUpperCase() + value.slice(1) : value;
    setValues({ ...values, [name]: value });
  };
  return (
    <div className="page-content mb-4">
      <Container>
        {id && (
          <Breadcrumbs
            title="State"
            breadcrumbItem={"State Edit"}
            path="/panel/state/list"
          />
        )}
        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
                <Formik
                  initialValues={values}
                  validationSchema={validationSchema}
                  enableReinitialize={true}
                  onSubmit={(val, acc) => handleSubmit(val, acc)}
                >
                  {({ errors, touched, values, setValues }) => (
                    <Form>
                      <Row>
                        <Col md="6">
                          <FormGroup>
                            <Label for="name">
                              State name <span className=" text-danger">*</span>
                            </Label>
                            <Field
                              type="text"
                              name="name"
                              id="name"
                              placeholder="Enter State name"
                              maxLength={100}
                              className={
                                "form-control" +
                                (errors.name && touched.name
                                  ? " is-invalid"
                                  : "")
                              }
                              onChange={e => handleChange(e, values, setValues)}
                              value={values.name}
                            />
                            <ErrorMessage
                              name="name"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>
                        <Col md="6">
                          <FormGroup>
                            <Label for="code">State code</Label>
                            <Field
                              type="text"
                              name="code"
                              id="code"
                              placeholder="Enter State code"
                              maxLength={4}
                              className={
                                "form-control" +
                                (errors.code && touched.code
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="code"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col md="6">
                          <div className="mt-4">
                            <h5 className="font-size-14 mb-1">
                              Status<span className=" text-danger"> *</span>
                            </h5>
                            <div className="d-flex">
                              <div className="form-check me-2">
                                <Field
                                  className="form-check-input"
                                  type="radio"
                                  name="status"
                                  id="active"
                                  value="1"
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="active"
                                >
                                  Active
                                </label>
                              </div>
                              <div className="form-check">
                                <Field
                                  className="form-check-input"
                                  type="radio"
                                  name="status"
                                  id="inactive"
                                  value="0"
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="inactive"
                                >
                                  Inactive
                                </label>
                              </div>
                            </div>
                          </div>
                        </Col>
                        <Col md="6">
                          <FormGroup>
                            <Label for="country">
                              Select country
                              <span className=" text-danger"> *</span>
                            </Label>
                            <Field
                              as="select"
                              name="country"
                              id="country"
                              className={
                                "form-select" +
                                (errors.country && touched.country
                                  ? " is-invalid"
                                  : "")
                              }
                            >
                              <option value={""}>Select country</option>
                              {country.map(value => (
                                <option value={value.id} key={value.id}>
                                  {value.name}
                                </option>
                              ))}
                            </Field>
                            {errors.country && touched.country ? (
                              <p className="text-danger mt-1">
                                {errors.country}
                              </p>
                            ) : null}
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={{ size: 2, offset: 5 }}>
                          <Button color="primary" type="submit">
                            Save
                          </Button>
                        </Col>
                      </Row>
                    </Form>
                  )}
                </Formik>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Loader(StateAdd);
